/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AzureServiceBusConfig,
  AzureServiceBusConfig$inboundSchema,
  AzureServiceBusConfig$Outbound,
  AzureServiceBusConfig$outboundSchema,
} from "./azureservicebusconfig.js";
import {
  AzureServiceBusCredentials,
  AzureServiceBusCredentials$inboundSchema,
  AzureServiceBusCredentials$Outbound,
  AzureServiceBusCredentials$outboundSchema,
} from "./azureservicebuscredentials.js";
import {
  Topics,
  Topics$inboundSchema,
  Topics$Outbound,
  Topics$outboundSchema,
} from "./topics.js";

export type DestinationUpdateAzureServiceBus = {
  /**
   * "*" or an array of enabled topics.
   */
  topics?: Topics | undefined;
  /**
   * Optional JSON schema filter for event matching. Events must match this filter to be delivered to this destination.
   *
   * @remarks
   * Supports operators: $eq, $neq, $gt, $gte, $lt, $lte, $in, $nin, $startsWith, $endsWith, $exist, $or, $and, $not.
   * If null or empty, all events matching the topic filter will be delivered.
   * To remove an existing filter when updating a destination, set filter to an empty object `{}`.
   */
  filter?: { [k: string]: any } | null | undefined;
  config?: AzureServiceBusConfig | undefined;
  credentials?: AzureServiceBusCredentials | undefined;
  /**
   * Static key-value pairs merged into event metadata on every attempt.
   */
  deliveryMetadata?: { [k: string]: string } | null | undefined;
  /**
   * Arbitrary contextual information stored with the destination.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateAzureServiceBus$inboundSchema: z.ZodType<
  DestinationUpdateAzureServiceBus,
  z.ZodTypeDef,
  unknown
> = z.object({
  topics: Topics$inboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: AzureServiceBusConfig$inboundSchema.optional(),
  credentials: AzureServiceBusCredentials$inboundSchema.optional(),
  delivery_metadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "delivery_metadata": "deliveryMetadata",
  });
});
/** @internal */
export type DestinationUpdateAzureServiceBus$Outbound = {
  topics?: Topics$Outbound | undefined;
  filter?: { [k: string]: any } | null | undefined;
  config?: AzureServiceBusConfig$Outbound | undefined;
  credentials?: AzureServiceBusCredentials$Outbound | undefined;
  delivery_metadata?: { [k: string]: string } | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateAzureServiceBus$outboundSchema: z.ZodType<
  DestinationUpdateAzureServiceBus$Outbound,
  z.ZodTypeDef,
  DestinationUpdateAzureServiceBus
> = z.object({
  topics: Topics$outboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: AzureServiceBusConfig$outboundSchema.optional(),
  credentials: AzureServiceBusCredentials$outboundSchema.optional(),
  deliveryMetadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    deliveryMetadata: "delivery_metadata",
  });
});

export function destinationUpdateAzureServiceBusToJSON(
  destinationUpdateAzureServiceBus: DestinationUpdateAzureServiceBus,
): string {
  return JSON.stringify(
    DestinationUpdateAzureServiceBus$outboundSchema.parse(
      destinationUpdateAzureServiceBus,
    ),
  );
}
export function destinationUpdateAzureServiceBusFromJSON(
  jsonString: string,
): SafeParseResult<DestinationUpdateAzureServiceBus, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationUpdateAzureServiceBus$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationUpdateAzureServiceBus' from JSON`,
  );
}
